<template>
<div id="inwardsForm">
    <div class="container" style="position: relative;">
        <div class="pt-2">
            <button style="position: absolute;left:0;" v-if="formStep === 1" @click="formStep=0" class="pt-4 btn btn-lg">
                <i class="fas fa-fw fa-chevron-left"></i> Back to Step 1
            </button>
            <h1 class="h4 text-gray-900 mb-2 mt-4 text-center">{{form.branch | branchFilter}} Inward Goods Form Step {{formStep+1}}</h1>
        </div>
        <div v-if="success" class="alert alert-success">{{success}}</div>
        <div v-if="formStep === 0" id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4  mb-4">
            <div class="dataTables_length d-flex align-items-center justify-content-between" id="dataTable_length">
                <label class="m-0">
                    Show
                    <select v-model="limit" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select> entries
                </label>
                 <div class="custom-control custom-checkbox small ml-4 mr-auto">
                            <input v-model="hideProcessed" type="checkbox" class="custom-control-input" id="customCheck" />
                            <label class="custom-control-label" for="customCheck"><small>Hide Processed/Completed Jobs</small></label>
                </div>
                <div id="dataTable_filter" style="max-width:200px;" class="dataTables_filter input-group">
                    <input type="text" style="max-width:150px;" v-model="searchText" placeholder="Search by Job#" aria-label="Search" v-on:keyup.enter="search()" class="form-control" />
                    <div class="input-group-append">
                        <button @click="search()" type="button" class="btn btn-primary">
                            <i class="fas fa-search fa-sm"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-responsive-xl">
                <div>
                    <table class="table table-expand focused">
                        <thead>
                            <tr>
                                <th class="col-date">Created</th>
                                <th class="col-job">Job#</th>
                                <th class="col-job px-1">In</th>
                                <th class="col-date">Status</th>
                                <th>Business</th>
                                <!--<th>Name</th>-->
                                <th class="col-address">Address</th>
                            </tr>
                        </thead>
                        <tbody v-show="(job.status !== 'Completed' && job.status !== 'Finalise' && job.status !== 'Invoice' && job.status !== 'Data Destruction Complete' && job.status !== 'Cancelled') || !hideProcessed" v-for="(job, index) in jobs" v-bind:key="index" v-bind:class="{ rwexpand: rwExpand === index }">
                            <tr class="rw" @click="expandRow(index)">
                                <td class="col-date" :time="job.submitted">{{job.submitted | shortDate}}</td>
                                <td class="col-job">{{job.jobid | jobid}}</td>
                                <td class="col-job px-1"><i v-if="job.inwards && job.inwards.length > 0" class="text-info fas fa-fw fa-check-circle"></i></td>
                                <td class="col-date py-1">
                                    <span style="margin:auto 0;" :style="{ background: $options.filters.statusHex(job.status)}" class="badge badge-lg">{{job.status}}</span>
                                    <small v-if="job.statusChangeDate" style="color:#777;font-size: 11px; display: block; margin-top: 0px; margin-bottom: -2px;">Changed: {{job.statusChangeDate | shortDate}}</small>
                                </td>
                                <td>{{job.company}}</td>
                                <!--<td :title="job.name + ' (' + job.email + ')'">{{job.name}} ({{job.email}})</td>-->
                                <td class="col-address">
                                    {{job.address}}
                                    <i class="selector-arrow fas fa-fw fa-chevron-right"></i>
                                </td>
                            </tr>
                            <tr class="cl">
                                <td colspan="5">
                                    <div class="row cl-row">
                                        <div class="col-sm" style="width:50%">
                                            <div class="panel panel-default">
                                                <div class="panel-body">
                                                    <a style="max-width:100%;display:block;" v-if="job.attachment && checkIfImage(job.attachment)" :href="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+encodeURIComponent(job.attachment)">
                                                        <img style="" :data-src="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+encodeURIComponent(job.attachment)" :src="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+encodeURIComponent(job.attachment)" />
                                                    </a>
                                                    <table class="table table-striped detail-table mt-2" v-if="job.itemoption === 'manual'">
                                                        <thead>
                                                            <tr>
                                                                <th>Description</th>
                                                                <th>Qty</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, i) in job.items" v-bind:key="i">
                                                                <td>{{item.description}}</td>
                                                                <td>{{item.quantity}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm" style="width:50%">
                                            <div class="panel panel-default">
                                                <div class="panel-body">
                                                    <p v-if="job && job.assignedTo" class="mt-1">Assigned To: <strong>{{job.assignedTo}}</strong></p>
                                                    <p v-if="job.datadestruction !== 'No'" class="mt-2">Data Destruction: <strong>{{job.datadestruction}}</strong></p>
                                                    <p v-if="job.message" class="mt-2"><strong>Customer Message:</strong><br /> {{job.message}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div  class="flex justify-content-end ml-auto mb-auto">
                                           <button @click="selectedRow(job.jobid, false)" class="ml-auto btn-lg btn btn-secondary">Select Job</button>
                                           <LabelPrinter class="ml-4 btn-lg" v-if="job" :job="job" />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="d-flex justify-content-center paging_simple_numbers" id="dataTable_paginate">
                <ul class="pagination">
                    <li @click="prevEndAt()" class="paginate_button page-item previous" id="dataTable_previous" v-bind:class="{ disabled: endAt === maxLimit }">
                        <a href="#" aria-controls="dataTable" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                    </li>
                    <li @click="nextEndAt()" class="paginate_button page-item next" id="dataTable_next" v-bind:class="{ disabled: jobs.length < limit }">
                        <a href="#" aria-controls="dataTable" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
                    </li>
                </ul>
            </div>
            <h4 class="text-center text-align-center mt-4">Can't Find a Job? Create a new</h4>
            <div class="d-flex justify-content-center align-items-center pb-4">
                <button @click="selectedRow(false, false)" style="min-width:180px;" class="btn btn-lg btn-primary"><i class="fas fa-fw fa-briefcase mr-1"></i> Job</button>
                <p class="pt-3 px-2">or</p>
                <button @click="selectedRow(false, true)" style="min-width:180px;" class="btn btn-lg btn-primary"><i class="fas fa-fw fa-level-down-alt   "></i> Dropoff</button>
                <p class="pt-3 px-2">or</p>
                <button @click="selectedRow(false, true , true)" style="min-width:180px;" class="btn btn-lg btn-primary"><i class="fas fa-fw fa-exchange-alt"></i> Branch Transfer</button>
            </div>
        </div>
    </div>
    <div v-if="formStep === 1">
        <div class="container p-0">
            <!-- Outer Row -->
            <div class="row py-4 justify-content-center">
                <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 p-0">
                    <div class="o-hidden border-0">
                        <div class="p-0">
                            <!-- Nested Row within Card Body -->
                            <div class="py-2">
                                <form class="user" action autocomplete="off" @submit.prevent="submit()">
                                    <div class="px-2">
                                        <div class="form-group row required" v-if="form.branch !== 0 && form.branch !== 1">
                                            <label for="jobid" class="col-md-4 col-form-label col-form-label-lg text-md-right">ITRecycla Branch</label>
                                            <div class="col-md-4">
                                                <select v-model="form.branch" name="dataTable_length" required aria-controls="dataTable" class="custom-select custom-select-lg form-control form-control-sm">
                                                    <option :value="0">Wellington</option>
                                                    <option :value="1">Auckland</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group row required">
                                            <label for="jobid" class="col-md-4 col-form-label col-form-label-lg text-md-right">Your Name</label>
                                            <div class="col-md-4">
                                                <select v-model="form.entered" name="dataTable_length" required aria-controls="dataTable" class="custom-select custom-select-lg form-control form-control-sm">
                                                    <option :value="user" v-for="(user, i) in users" v-bind:key="i">{{user.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <hr />
                                        <!--<div class="form-group row">
                                            <label for="miscDrop" class="col-md-4 col-form-label text-md-right"></label>
                                            <div class="col-md-7 custom-control custom-checkbox">
                                                <input v-model="form.miscDrop" type="checkbox" class="custom-control-input" id="customCheck">
                                                <label class="custom-control-label" for="customCheck">Is this a Misc/Random Dropoff</label>
                                            </div>
                      </div>-->
                                        <div class="d-sm-flex align-items-center justify-content-center mb-1" v-if="job.jobid">
                                            <h3 class="h5 mb-0 text-gray-800 mr-2">Job Details: <strong>#{{form.jobid}}</strong></h3>
                                        </div>
                                        <div v-if="job.jobid" class="d-sm-flex align-items-center justify-content-center mb-2"><span>Status: <strong v-if="job && job.status" class="badge badge-lg mr-2" :style="{ background: $options.filters.statusHex(job.status)}">{{job.status}}</strong></span><span class="ml-2" v-if="job && job.assignedTo">Assigned To: <strong>{{job.assignedTo}}</strong></span></div>

                                        <div class="form-group row" v-if="!form.miscDrop">
                                            <label for="from" class="col-md-4 col-form-label col-form-label-lg text-md-right">Customer Business</label>
                                            <div class="col-md-6">
                                                <h4 v-if="!eMode && job.jobid" class="pt-1 m-0">{{job.company}}</h4>
                                                <input v-if="eMode || !job.jobid" id="from" type="text" class="form-control form-control-lg" name="company" required v-model="job.company" />
                                            </div>
                                        </div>
                                        <div class="form-group row required" v-if="!form.miscDrop">
                                            <label for="from" class="col-md-4 col-form-label col-form-label-lg text-md-right">Customer Contact Name</label>
                                            <div class="col-md-6">
                                                <h4 v-if="!eMode && job.jobid" class="pt-1 m-0">{{job.name}}</h4>
                                                <input v-if="eMode || !job.jobid" id="name" type="text" class="form-control form-control-lg" name="name" required v-model="job.name" />
                                            </div>
                                        </div>
                                        <div class="form-group row required" v-if="!form.miscDrop">
                                            <label for="site" class="col-md-4 col-form-label col-form-label-lg text-md-right">Arrived From Address</label>
                                            <div class="col-md-8">
                                                <h4 v-if="!eMode && job.jobid" class="pt-2 m-0">{{job.address}}</h4>
                                                <!--<input v-if="eMode || !job.jobid" id="site" type="text" class="form-control form-control-lg" name="site" required v-model="job.address" />-->

                                                <address-autocomplete classes="form-control-lg" v-if="eMode || !job.jobid" :address.sync="job.address" />
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="!form.miscDrop">
                                            <label for="custJob" class="col-md-4 col-form-label col-form-label-lg text-md-right">Customer Job #</label>
                                            <div class="col-md-4">
                                                <h4 v-if="!eMode && job.jobid" class="pt-2 m-0">{{form.custJob}}</h4>
                                                <input v-if="eMode || !job.jobid" id="from" type="text" class="form-control form-control-lg " name="custJob" v-model="job.custJob" />
                                            </div>
                                        </div>

                                        <div class="form-group row" v-if="!form.miscDrop">
                                            <label for="custJob" class="col-md-4 col-form-label col-form-label-lg text-md-right">Job Items</label>
                                            <div class="col-md-8">
                                                <table class="mb-1 table table-striped detail-table">
                                                    <thead>
                                                        <tr>
                                                            <td><strong>Description</strong></td>
                                                            <td><strong>Quantity</strong></td>
                                                            <td class="col-job" v-if="eMode"></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, i) in job.items" v-bind:key="i">
                                                            <td v-if="!eMode && job.jobid"><strong>{{item.description}}</strong></td>
                                                            <td v-if="eMode || !job.jobid" class="p-1"><input :id="'description'+i" type="text" class="form-control mb-0" :name="'description'+i" v-model="item.description" /></td>
                                                            <td v-if="!eMode && job.jobid">{{item.quantity}}</td>
                                                            <td v-if="eMode || !job.jobid" class="p-1"><input min="0" pattern="[0-9]*" inputmode="numeric" :id="'qty'+i" type="number" class="form-control mb-0" :name="'qty'+i" v-model="item.quantity" />
                                                            <td class="col-job p-2" v-if="eMode || !job.jobid"><button class="btn btn-sm" @click="deleteItem(i)"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot v-if="eMode || !job.jobid">
                                                        <td class="py-0" colspan="2"><button type="button" @click="addNewItem()" class="mt-1 btn btn-secondary"><i class="fas fa-fw fa-plus"></i> Add New Item</button></td>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="form-group row required" v-if="!form.miscDrop">
                                            <label for="jobid" class="col-md-4 col-form-label col-form-label-lg text-md-right">Data Security</label>
                                            <div class="col-md-4">
                                                <h4 v-if="!eMode && job.jobid" class="pt-1 m-0">{{job.datadestruction}}</h4>
                                                <select v-if="eMode || !job.jobid" v-model="job.datadestruction" name="dataTable_length" required class="custom-select custom-select-lg form-control form-control-sm">
                                                    <option value selected>Is Data Destruction Required?</option>
                                                    <option value="No">No</option>
                                                    <option value="Erase">Erasure</option>
                                                    <option value="Shred">Shred</option>
                                                    <option value="Degauss">Degaussing</option>
                                                    <option value="Degauss & Shred">Degauss & Shred Combo</option>
                                                    <option value="NZISM">NZISM Disintegration</option>
                                                </select>
                                            </div>
                                            <div class="col-md-4">
                                                <div v-if="job.datadescruction && job.datadestruction !== 'No'" class="d-inline-block m-0 alert alert-danger"><i class="fas fa-fw fa-database"></i> {{job.datadestruction}}</div>
                                            </div>
                                        </div>
                                        <div v-if="job.jobid" class="d-flex justify-content-center">
                                            <button type="button" v-if="!eMode" @click="toggleEdit()" class="btn btn-secondary"><i class="fas fa-fw fa-edit"></i> Edit Job Details</button>
                                            <button type="button" v-if="eMode" @click="cancelEdit()" class="btn btn-info mr-2">Cancel</button>
                                        </div>
                                        <hr v-if="!form.miscDrop" />
                                        <div class="form-group row" v-if="!form.miscDrop">
                                            <label for="note" class="col-md-4 col-form-label col-form-label-lg text-md-right">Add a new Note for Job #{{job.jobid | jobid}}:</label>
                                            <div class="col-md-6">
                                                <textarea placeholder="Enter notes i.e. financial info etc" id="note" class="form-control form-control-lg" name="note" value v-model="form.note"></textarea>
                                            </div>
                                            <div class="col-md-2 d-flex align-items-bottom">
                                                <button style="margin-top:auto" type="submit" id="saveNote" class="btn btn-secondary"><i class="fas fa-fw fa-plus"></i> Save New Note</button>
                                            </div>
                                        </div>

                                        <hr v-if="!form.miscDrop" />
                                        <div class="form-group row required" v-if="!form.miscDrop">
                                            <label for="numItems" class="col-md-4 col-form-label col-form-label-lg text-md-right"># Drums/Pallets</label>
                                            <div class="col-md-4">
                                                <input id="numItems" pattern="[0-9]*" inputmode="numeric" min="0" value="0" style="max-width:90px;" placeholder="0" type="number" class="form-control form-control-lg" name="numItems" required v-model="form.numItems" />
                                            </div>
                                        </div>
                                        <div class="form-group row required">
                                            <label for="weight" class="col-md-4 col-form-label col-form-label-lg text-md-right">Total Weight</label>
                                            <div class="col-md-3">
                                                <input id="weight" pattern="[0-9]*" inputmode="numeric" value="0" style="max-width:90px;" placeholder="0" type="text" class="form-control form-control-lg d-inline" name="weight" required v-model="form.weight" />
                                                <span class="d-inline">&nbsp;kg</span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="d-flex justify-content-center">
                                        <button type="submit" id="sendlogin" class="btn btn-lg btn-primary">Save Inward Stock</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    db
} from "../main";
import {
    mapGetters
} from "vuex";

import saveNoteMixin from "../mixins/saveNotes";
const jobsRef = db.ref("jobs2020");
const jobCounterRef = db.ref("jobcounter");
import AddressAutocomplete from "@/components/AddressAutocomplete";
import LabelPrinter from "@/components/LabelPrinter";

export default {
    name: "InwardGoods",
    components: {
        AddressAutocomplete,
        LabelPrinter
    },
    mixins: [saveNoteMixin],
    data: function () {
        return {
            jobsRaw: [],
            limit: 25,
            //startAt: 0,
            maxLimit: 100000,
            endAt: 100000,
            jobOriginal: null,
            pageNo: 1,
            searchText: "",
            formStep: 0,
            eMode: false,
            hideProcessed:true,
            form: {
                jobid: null,
                address: null,
                name: null,
                company: null,
                miscDrop: false,
                carrier: null,
                //datadestruction: null,
                numItems: null,
                weight: null,
                isTransfer: false,
                branch: parseInt(this.$route.query.branch),
                entered: null,
                note: null,
            },
            rwExpand: null,
            jobSearch: [],
            job: {},
            users: [],
            error: null,
            success: null,
        };
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        }),
        jobs: function () {
            return [...this.jobsRaw].reverse();
        },
        combinedWatch() {
            return this.limit + this.endAt;
        },
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(6),
    },
    methods: {
        toggleEdit() {
            const t = this;
            t.eMode = !t.eMode;
            t.clearOldStatus();

        },
        cancelEdit() {
            const t = this;
            t.toggleEdit();
            t.clearOldStatus();
            //t.job = JSON.parse(JSON.stringify(t.jobOriginal));
        },
        clearOldStatus() {
            const t = this;
            t.success = null;
            t.error = null;
        },
        createNewJob() {
            this.job = {
                datadestruction: null,
                items: [],
                itemoption: "manual",
                custJob: null,
                company: null,
                name: null,
                address: null,
            }
            this.addNewItem();
        },
        deleteItem(i) {
            const t = this;
            console.log(t.job.items);
            console.log(typeof t.job.items);
            t.job.items.splice(i, 1);
            console.log(t.job.items);
        },
        addNewItem() {
            this.clearOldStatus();
            var item = {
                description: '',
                item: ''
            }
            this.job.items.push(item);
        },
        checkIfImage(filename) {
            var fileExt = filename.substr(filename.lastIndexOf(".") + 1);
            switch (fileExt.toLowerCase()) {
                case "jpg":
                case "jpeg":
                case "png":
                case "gif":
                    return true;
                default:
                    return false;
            }
        },
        expandRow(index) {
            //this.$set(this.rwExpand, index, !this.rwExpand[index]);
            if (this.rwExpand !== index) {
                this.rwExpand = index;
            } else {
                this.rwExpand = null;
            }
            console.log(this.rwExpand);
        },
        selectedRow(jobid, isMisc, isTransfer) {
            if (isTransfer) {
                this.form.isTransfer = isTransfer;
            }
            if (isMisc) {
                this.form.miscDrop = isMisc;
            }
            this.success = null;
            if (jobid) {
                this.form.jobid = jobid.toString().substring(1); //remove leading 1
            } else if (!isMisc) {
                this.createNewJob();
            } else {
                this.job = {};
                this.form.jobid = "";
            }
            this.formStep = 1;
        },
        nextEndAt() {
            this.pageNo += 1;
            this.startAt = this.jobs[0].jobid;
            this.endAt = this.jobs[this.jobs.length - 1].jobid;
            console.log(this.endAt);
            this.rwExpand = null;
        },
        prevEndAt() {
            this.pageNo -= 1;
            if (this.pageNo != 1) {
                this.endAt = this.startAt;
            } else {
                this.endAt = this.maxLimit;
            }
            //this.endAt = 100000;
            console.log(this.startAt);
            this.rwExpand = null;
        },
        search() {
            this.selectedRow('1' + this.searchText.trim(), false);
        },
        createInwards(job) {
            const t = this;

            t.clearOldStatus();
            /*  const job = {
                  ...jobIn
              };*/
            var inwardsObj = {};

            if (job && job['.key']) {
                inwardsObj = {
                    jobid: job.jobid,
                    company: job.company,
                    address: job.address,
                    name: job.name,
                    carrier: t.form.carrier,
                    numItems: parseInt(t.form.numItems, 10),
                    branch: t.form.branch,
                    weight: parseInt(t.form.weight, 10),
                    enteredby: t.form.entered.name,
                    enteredUID: t.form.entered['.key'],
                    submitted: new Date().toISOString(),
                }
            } else {
                inwardsObj = {
                    branch: t.form.branch,
                    isTransfer: t.form.isTransfer,
                    miscDrop: t.form.miscDrop,
                    weight: parseInt(t.form.weight, 10),
                    enteredby: t.form.entered.name,
                    enteredUID: t.form.entered['.key'],
                    submitted: new Date().toISOString(),
                }
            }
            db.ref("inwardGoods/")
                .push(inwardsObj)
                .then((snap) => {
                    const key = snap.key;
                    console.log(key);
                    console.log('inward created!')
                    console.log('jobkey', job['.key']);
                    if (job['.key']) { //Job Exisits

                        if (!job.inwards) {
                            job.inwards = [];
                        }
                        job.inwards.push(key);
                        job.status = "Inwards Recorded";
                        job.statusChangeDate = new Date().toISOString();

                        console.log('jobInwards', job);
                        if (t.jobOriginal !== null) {
                            t.saveNote(JSON.stringify(t.diffObj(job, t.jobOriginal)), job, 'Edit');
                        }

                        db.ref('jobs2020/' + job['.key'])
                            .set(job)
                            .then(() => {
                                console.log('job updated!')
                                t.success = "Inward Goods Recorded & Job Saved";
                                t.resetForm();
                                if (t.form.note) {
                                    t.saveNote(t.form.note.trim(), job, 'Note')
                                }

                            })
                    } else {
                        t.success = "Inward Goods Entry Recorded";
                        t.resetForm();
                    }
                });

        },
        submit() {
            const t = this;
            console.log('job', t.job);

            /*const job = {
                ...t.job
            };*/
            var job = t.job;

            if (!t.form.miscDrop && !t.job['.key']) { //No Job Create a New One

                //First Get Job Id Counter value
                jobCounterRef.once('value', snapshot => {
                    console.log('snap', snapshot.val())

                    var newJobId = snapshot.val() + 1;
                    //Final Job Fields
                    job.jobid = newJobId;
                    job.submitted = new Date().toISOString();
                    job.enteredby = t.form.entered.name;
                    job.enteredUID = t.form.entered['.key'];
                    job.status = "Created";
                    //Push new job
                    jobsRef
                        .push(job)
                        .then((snap) => {
                            console.log('job created!', snap);

                            //Update job counter value
                            jobCounterRef.set(newJobId)
                                .then(() => {
                                    console.log('job counter updated!')
                                    job = t.jobs[0];
                                    t.createInwards(job);
                                })

                        })
                })

            } else {
                t.createInwards(t.job);
            }
        },
        resetForm() {
            console.log("Reseting the form");
            const t = this; //you need this because *this* will refer to Object.keys below`
            this.rwExpand = null;
            this.job = {};
            this.jobOriginal = null;
            //Iterate through each object field, key is name of the object field`
            Object.keys(t.form).forEach(function (key) {
                if (key !== "branch" && key !== 'entered') {
                    t.form[key] = null;
                }
            });
            t.formStep = 0;
        },
    },
    created() {
        // this.selectedRow(12802);

    },
    watch: {
        "user.data": {
            // call it upon creation too
            immediate: false,
            handler(userData) {
                console.log('userData', userData);
                if (userData.role === 5) {
                    this.form.branch = userData.phone;
                    console.log('branch', this.form.branch)
                }
            }
        },
        "form.jobid": {
            // call it upon creation too
            immediate: false,
            handler(jobid) {
                console.log(jobid);
                this.error = null;
                if (jobid && jobid.length === 4) {
                    this.$rtdbBind(
                        "jobSearch",
                        jobsRef.orderByChild("jobid").equalTo(parseInt("1" + jobid, 10))
                    ).then(() => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        console.log("job", this.jobSearch[0]);
                        if (this.jobSearch[0]) {
                            this.job = this.jobSearch[0];
                            this.jobOriginal = JSON.parse(JSON.stringify(this.jobSearch[0]));
                            this.form.company = this.job.company;
                            this.form.name = this.job.name;
                            this.form.address = this.job.address;
                            //this.form.datadestruction = this.job.datadestruction;
                        } else {
                            this.error = "Job# " + jobid + " not found";
                        }
                        //this.jobsRaw === jobsRaw;
                    });
                }
            },
        },
        combinedWatch: {
            // call it upon creation too
            immediate: true,
            handler() {
                this.$rtdbBind(
                    "jobsRaw",
                    jobsRef
                    .orderByChild("jobid")
                    .limitToLast(this.limit)
                    .endAt(this.endAt)
                );
            },
        },
    },
};
</script>

<style>
#inwardsForm #saveNote {
    display: none;
}
</style>
